import { render, staticRenderFns } from "./communicationDeta.vue?vue&type=template&id=4eec257d&scoped=true"
import script from "./communicationDeta.vue?vue&type=script&lang=js"
export * from "./communicationDeta.vue?vue&type=script&lang=js"
import style0 from "./communicationDeta.vue?vue&type=style&index=0&id=4eec257d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec257d",
  null
  
)

export default component.exports